import { Outlet } from 'react-router-dom';

// project imports
import Customization from '../Customization';
import ProfileSection from '../MainLayout/Header/ProfileSection';
import LogoSection from '../MainLayout/LogoSection';
import { AppBar, Box, CssBaseline, Toolbar } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import ReactLoading from 'react-loading';
import { useAuth0, withAuthenticationRequired } from '@auth0/auth0-react';
import UnitSelection from 'views/pages/unitselection';

// ==============================|| MINIMAL LAYOUT ||============================== //

const MinimalLayout = () => {
    const { isLoading, isAuthenticated, loginWithRedirect } = useAuth0();
    const theme = useTheme();

    return (
        <Box sx={{ display: 'flex', flexDirection: 'column' }}>
            <CssBaseline />
            {/* header */}
            <AppBar
                enableColorOnDark
                position="fixed"
                color="inherit"
                elevation={0}
                sx={{
                    bgcolor: theme.palette.background.default
                }}
            >
                <Toolbar sx={{ minHeight: 48, height: 48, mt: 1, mb: 0 }}>
                    <Box component="span" sx={{ display: { xs: 'none', md: 'block' }, flexGrow: 1 }}>
                        <LogoSection />
                    </Box>
                    <Box sx={{ flexGrow: 1 }} />
                    <ProfileSection />
                </Toolbar>
            </AppBar>

            {/* main content */}
            <Box component="main" sx={{ mt: '65px', flexGrow: 1 }}>
                <UnitSelection />
                <Outlet />
            </Box>
            {/* <Customization /> */}
        </Box>
    );
};

export default withAuthenticationRequired(MinimalLayout, {
    onRedirecting: () => <ReactLoading type="Spin" color="#fff" />
});
